import { render, staticRenderFns } from "./ShopComponent.vue?vue&type=template&id=759ff783&scoped=true&"
import script from "./ShopComponent.vue?vue&type=script&lang=js&"
export * from "./ShopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759ff783",
  null
  
)

export default component.exports